// GET Requests
export const DOCS_MANUAL = '/docs/manual';
export const DOCS_MANUAL_KEY = '/docs/manual_url';
export const USERS_FETCH = '/users/full';
export const VIDEOS_LIST = '/videos/list';

// POST Requests
export const USERS_LOGIN = '/users/login';
export const USERS_SUPPORT = '/users/support/submit';
export const VIDEOS_COMPLETE = '/videos/complete';


// WEBPACK FOOTER //
// ./src/constants/endpoints.jsx